import { useLanguage } from "@/i18n";

const PHOTOS = [
  { src: "/images/procida-corricella.jpeg", label: "Procida · Marina Corricella" },
  { src: "/images/ischia-castello.jpeg", label: "Ischia · Castello Aragonese" },
  { src: "/images/pompei-vesuvio.jpeg", label: "Pompei · Vesuvio" },
  { src: "/images/kayak-tramonto.jpeg", label: "Napoli · Kayak al tramonto" },
  { src: "/images/capri-faraglioni.jpeg", label: "Capri · Faraglioni" },
  { src: "/images/pozzuoli-night.jpeg", label: "Pozzuoli · Rione Terra" },
  { src: "/images/piscina-mirabilis.jpeg", label: "Bacoli · Piscina Mirabilis" },
  { src: "/images/napoli-marechiaro.jpeg", label: "Napoli · Marechiaro" },
  { src: "/images/mare-stella.jpeg", label: "Costa flegrea · Swim stop" },
  { src: "/images/pompei-aerea.jpeg", label: "Pompei · Vista aerea" },
  { src: "/images/ischia-santangelo.jpeg", label: "Ischia · Sant'Angelo" },
  { src: "/images/pozzuoli-coast.jpeg", label: "Pozzuoli · Costa" },
  { src: "/images/napoli-plebiscito.jpeg", label: "Napoli · Piazza del Plebiscito" },
  { src: "/images/napoli-sotterranea.jpeg", label: "Napoli Sotterranea" },
  { src: "/images/caserta-scalone.jpeg", label: "Reggia di Caserta · Scalone" },
  { src: "/images/caserta-reggia.jpeg", label: "Reggia di Caserta" },
  { src: "/images/cristo-velato.jpeg", label: "Napoli · Cristo Velato" },
  { src: "/images/baia-sommersa-wide.jpeg", label: "Baia Sommersa" },
  { src: "/images/baia-sommersa-statua.jpeg", label: "Baia Sommersa · Ninfeo" },
  { src: "/images/lago-averno.jpeg", label: "Lago d'Averno · Tempio di Apollo" },
  { src: "/images/monte-nuovo.jpeg", label: "Monte Nuovo · Cratere" },
  { src: "/images/solfatara-crater.jpeg", label: "Solfatara · Cratere" },
];

export default function PhotoCarousel() {
  const { t } = useLanguage();
  const row = [...PHOTOS, ...PHOTOS];
  return (
    <section className="py-20 overflow-hidden" data-testid="photo-carousel-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 mb-10 flex items-end justify-between gap-6">
        <div>
          <div className="flex items-center gap-3 mb-4">
            <span className="block w-10 h-px bg-terracotta" />
            <p className="text-[11px] font-medium uppercase tracking-[0.25em] text-medblue">{t("carousel_overline")}</p>
          </div>
          <h2 className="font-serif text-4xl md:text-5xl text-ink tracking-tight">{t("carousel_title")}</h2>
        </div>
        <p className="hidden md:block text-sm text-ink/50 max-w-xs leading-relaxed">{t("carousel_sub")}</p>
      </div>
      <div className="relative" data-testid="photo-carousel">
        <div className="carousel-track flex gap-4 w-max">
          {row.map((p, i) => (
            <figure key={i} className="relative w-64 md:w-80 aspect-[4/5] overflow-hidden shrink-0 group">
              <img src={p.src} alt={p.label} loading="lazy" className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-105" />
              <figcaption className="absolute bottom-0 inset-x-0 bg-gradient-to-t from-black/60 to-transparent p-4 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <span className="text-ivory text-xs tracking-wide">{p.label}</span>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
